import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const UserRoute = () => {
  const { user, cargando } = useAuth();

  if (cargando) return <div>Cargando...</div>;

  // Permitir acceso si el rol es "user" o "admin"
  return user && (user.role === "user" || user.role === "admin") ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default UserRoute;
